import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const preregister = async (body) => {
  const response = await axios.post(
    routes.preregister,
    { ...body },
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};
export default preregister;
